import('./bootstrap').catch((err) => console.error(err));
import '@angular/compiler';
